import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import styled from 'styled-components';
import Image from 'next/legacy/image';
import { useState } from 'react';
import { HTTPMethod } from 'http-method-enum';
import { useRouter } from 'next/router';
import { Card } from '@yoweb/ui/components/containers';
import { Text, Title } from '@yoweb/ui/components/typography';
import { Badge } from '@yoweb/ui/components/indicators';
import { useTranslation } from '@yoweb/next-i18next';
import { Box } from '@yoweb/ui/components/Box';
import { ButtonIcon } from '@yoweb/ui/components/buttons';
import { AddIcon } from '@yoweb/ui/components/Icon/AddIcon';
import { CardButtonWrapper } from '@poplar/components/TaskTemplate/CardButtonWrapper';
import { pxToRem } from '@yoweb/ui/styles/utils';
import { BookmarkIcon } from '@yoweb/ui/components/Icon/BookmarkIcon';
import { theme } from '@yoweb/ui/styles';
import { PAGE_TODO_DETAILS, API_TASK_TEMPLATE_ID } from '@poplar/constants/routes';
import { Spinner } from '@yoweb/ui/components/Spinner';
import { createTask, deleteTask } from '@poplar/lib/api/tasks';
import { useToast } from '@yoweb/ui/hooks/useToast';
import { fetchJson } from '@yoweb/utils/fetchJson';
import { LineClamp } from '@yoweb/ui/components/LineClamp';
import { trackEvent } from '@yoweb/utils/analytics/mixpanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MAX_LINE_CLAMP = 3;
export var LargeFeatureCard = function LargeFeatureCard(_ref) {
  var card = _ref.card,
      onClick = _ref.onClick,
      cursor = _ref.cursor,
      onBookmarkUpdate = _ref.onBookmarkUpdate;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var _useToast = useToast(),
      showToastAction = _useToast.showToastAction,
      showToastMessage = _useToast.showToastMessage;

  var router = useRouter();
  var isBookmarked = !!card.bookmarkTaskId.length;
  return /*#__PURE__*/_jsx(StyledCardButtonWrapper, {
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(function () {
      onClick();
      trackEvent({
        featuredTodoView: {
          title: card.title
        }
      });
    }),
    cursor: cursor,
    children: /*#__PURE__*/_jsxs(Card, {
      display: "flex",
      flexDirection: "column",
      gap: "small4",
      radii: "small",
      width: "100%",
      "data-testid": "large-feature-card",
      height: "100%",
      p: "none",
      children: [/*#__PURE__*/_jsxs(Box, {
        display: "flex",
        position: "relative",
        children: [card.bannerImageUrl ? /*#__PURE__*/_jsx(Box, {
          width: "100%",
          pt: "75%",
          children: /*#__PURE__*/_jsx(StyledImage, {
            src: card.bannerImageUrl,
            layout: "fill",
            objectFit: "cover"
          })
        }) : /*#__PURE__*/_jsx(Box, {
          width: 348,
          height: 261,
          backgroundColor: "base050"
        }), /*#__PURE__*/_jsxs(BadgeContainer, {
          children: [card.isTaskTemplateForDogfoodTesting && /*#__PURE__*/_jsx(Badge, {
            type: "fill",
            backgroundColor: "warningLight",
            borderRadius: "tiny",
            children: t('todo-intake.testing')
          }), card.templateBadgesList.map(function (badge) {
            return /*#__PURE__*/_jsx(Badge, {
              type: "fill",
              backgroundColor: "skyLight",
              borderRadius: "tiny",
              children: badge
            }, badge);
          })]
        }), /*#__PURE__*/_jsx(Box, {
          position: "absolute",
          right: 16,
          top: 16,
          children: /*#__PURE__*/_jsx(ButtonIcon, {
            as: "div",
            "aria-label": t('actions.bookmark'),
            "data-testid": isLoading ? undefined : 'large-feature-card-bookmark-btn',
            onClick: /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var taskTemplateData, task;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        e.stopPropagation();

                        if (isLoading) {
                          _context.next = 19;
                          break;
                        }

                        setIsLoading(true);

                        if (!isBookmarked) {
                          _context.next = 9;
                          break;
                        }

                        _context.next = 6;
                        return deleteTask(card.bookmarkTaskId);

                      case 6:
                        showToastMessage({
                          message: t('task-removed-from-drafts', {
                            todoName: card.title
                          })
                        });
                        _context.next = 16;
                        break;

                      case 9:
                        _context.next = 11;
                        return fetchJson(API_TASK_TEMPLATE_ID(card.taskTemplateId), {
                          method: HTTPMethod.GET,
                          headers: {
                            'Cache-Control': 'no-cache'
                          }
                        });

                      case 11:
                        taskTemplateData = _context.sent;
                        _context.next = 14;
                        return createTask(_objectSpread(_objectSpread({}, taskTemplateData), {}, {
                          isBookmarkTask: true
                        }));

                      case 14:
                        task = _context.sent;

                        if (task.data) {
                          showToastAction({
                            message: t('task-saved-to-drafts', {
                              todoName: task.data.name
                            }),
                            ctaText: t('toasts.view-todo', {
                              ns: 'common'
                            }),
                            onClick: function onClick() {
                              var _task$data;

                              return (_task$data = task.data) !== null && _task$data !== void 0 && _task$data.taskId ? router.push(PAGE_TODO_DETAILS(task.data.taskId)) : undefined;
                            }
                          });
                        }

                      case 16:
                        _context.next = 18;
                        return onBookmarkUpdate === null || onBookmarkUpdate === void 0 ? void 0 : onBookmarkUpdate();

                      case 18:
                        setIsLoading(false);

                      case 19:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }(),
            variant: "primary",
            icon: isLoading ? /*#__PURE__*/_jsx(Spinner, {
              size: "sm"
            }) : /*#__PURE__*/_jsx(BookmarkIcon, {
              size: 16,
              fill: isBookmarked ? theme.colors.charcoal : theme.colors.base000
            }),
            size: "sm",
            radius: "full",
            mode: "dark"
          })
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        gap: "small3",
        p: "normal1",
        pt: 0,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Title, {
          size: "sm",
          title: card.title,
          children: /*#__PURE__*/_jsx(LineClamp, {
            lines: MAX_LINE_CLAMP,
            children: card.title
          })
        }), /*#__PURE__*/_jsxs(Box, {
          display: "flex",
          gap: "small3",
          justifyContent: "space-between",
          flex: "1",
          children: [/*#__PURE__*/_jsx(Box, {
            height: 72,
            children: /*#__PURE__*/_jsx(Text, {
              title: card.description,
              children: /*#__PURE__*/_jsx(LineClamp, {
                lines: MAX_LINE_CLAMP,
                children: card.description
              })
            })
          }), /*#__PURE__*/_jsx(Box, {
            display: "flex",
            alignItems: "flex-end",
            children: /*#__PURE__*/_jsx(ButtonIcon, {
              as: "div",
              mode: "dark",
              size: "md",
              isFloating: false,
              icon: /*#__PURE__*/_jsx(AddIcon, {
                size: 18
              }),
              bgColor: "gingko"
            })
          })]
        })]
      })]
    })
  });
};
var StyledCardButtonWrapper = styled(CardButtonWrapper).withConfig({
  componentId: "sc-5yz2k7-0"
})(["&&{cursor:", ";margin:", ";width:100%;height:100%;}"], function (_ref3) {
  var cursor = _ref3.cursor;
  return cursor !== null && cursor !== void 0 ? cursor : 'pointer';
}, pxToRem(1));
var StyledImage = styled(Image).withConfig({
  componentId: "sc-5yz2k7-1"
})(["&&{border-radius:0.41rem 0.41rem 0 0;user-drag:none;user-select:none;}"]);
var BadgeContainer = styled.div.withConfig({
  componentId: "sc-5yz2k7-2"
})(["position:absolute;display:flex;left:", ";top:", ";div:not(:first-child){margin-left:6px;}"], pxToRem(16), pxToRem(16));